import { InputType, Locale } from 'src/types'

export function getFieldsForEditCarInfo(
  locale: Locale['userData'],
  distanceMetric: string,
) {
  /* eslint-disable @typescript-eslint/naming-convention */
  const {
    carNumber,
    licensePlate_placeholder,
    carBrand,
    carBrand_placeholder,
    carModel,
    carModel_placeholder,
    vin,
    vin_placeholder,
    mileage,
    mileage_placeholder,
    year,
    year_placeholder,
    engineType,
    engineType_placeholder,
  } = locale

  /* eslint-enable @typescript-eslint/naming-convention */

  return [
    {
      title: carNumber,
      placeHolder: licensePlate_placeholder,
      name: 'carNumber',
      inputType: InputType.TEXT,
    },
    {
      title: carBrand,
      placeHolder: carBrand_placeholder,
      name: 'carBrand',
      inputType: InputType.TEXT,
    },
    {
      title: carModel,
      placeHolder: carModel_placeholder,
      name: 'carModel',
      inputType: InputType.TEXT,
    },
    {
      title: vin,
      placeHolder: vin_placeholder,
      name: 'vin',
      inputType: InputType.TEXT,
    },
    {
      title: `${mileage} (${distanceMetric})`,
      placeHolder: mileage_placeholder,
      name: 'mileage',
      inputType: InputType.NUMBER,
    },
    {
      title: year,
      placeHolder: year_placeholder,
      name: 'year',
      inputType: InputType.NUMBER,
    },
    {
      title: engineType,
      placeHolder: engineType_placeholder,
      name: 'engineType',
      inputType: InputType.TEXT,
    },
  ] as const
}
